import { useQuery } from "@tanstack/react-query";
import { Button, message, Modal, Tag } from "antd";
import { useState } from "react";
import {
  acceptCardDeletions,
  getCardDeletions,
} from "../actions/stampcard_action";
import TableMed from "../components/TableMed";
import Loading from "../utils/Loading";

const getStatusTag = (status) => {
  const colorMap = {
    COMPLETED: "green",
    PENDING: "orange",
    FAILED: "red",
    CANCELLED: "volcano",
  };
  return <Tag color={colorMap[status] || "blue"}>{status}</Tag>;
};

export default function CardDeletionsTab() {
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
  });

  const { refetch, isLoading, data } = useQuery({
    queryKey: ["card-deletions"],
    queryFn: () =>
      getCardDeletions({
        currentPage: pagination.currentPage,
        pageSize: pagination.pageSize,
      }),
  });

  console.log(data);

  const handleDelete = (id) => {
    Modal.confirm({
      title: "Are you sure you want to delete this request?",
      content: "Once deleted, this action cannot be undone.",
      okText: "Yes, Delete",
      cancelText: "Cancel",
      onOk: () => {
        acceptCardDeletions(id)
          .then(() => {
            refetch();
            message.success("Request is deleted successfully.");
          })
          .catch(() => {
            message.error("Something went wrong !!.");
          });
      },
    });
  };

  const handlePaginationChange = (page, size) => {
    setPagination({ currentPage: page, pageSize: size });
  };

  if (isLoading) return <Loading />;

  const columns = [
    {
      title: "Account Name",
      key: "account_name",
      render: (_, record) => record.account?.name || "N/A",
    },
    { title: "Account Urn", dataIndex: "account_urn", key: "account_urn" },
    {
      title: "Card Urn",
      dataIndex: "loyalty_scheme_urn",
      key: "loyalty_scheme_urn",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: getStatusTag,
    },
    { title: "Reason", dataIndex: "reason", key: "reason" },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button danger onClick={() => handleDelete(record.id)}>
          Delete
        </Button>
      ),
    },
  ];

  return (
    <TableMed
      columns={columns}
      data={data?.body?.docs}
      onPaginationChange={handlePaginationChange}
    />
  );
}
